import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const UserGreeting = styled.div`
  font-size: 20px;
  margin-right: 40px;
  color: var(--titleColor);
`;

export { Container, UserGreeting };
